import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import { Provider } from 'jotai';
import { buildDashboardStore } from '@src/atoms/utils';
import MetricLens from '@components/metric-lens';
import { PAGE_TYPE } from '@utils/constants';
import { selectors as tabsStoreSelector } from '@store/dashboards/tabs';
import usePageTitle from '@src/hooks/usePageTitle';
import { Wrapper } from './styled';

const defaultStore = buildDashboardStore();

const Dashboard = (props) => {
  const { match, pageType, mlBase, store = defaultStore } = props;
  const currentShareId = get(match, 'params.id', 'metriclens');
  const tabs = useSelector(tabsStoreSelector);

  usePageTitle({ text: 'Metric Lens' });

  useEffect(() => {
    if (
      pageType === PAGE_TYPE.SHARING &&
      tabs.tabsData[currentShareId] &&
      !isEqual(mlBase, tabs.tabsData[currentShareId].config.base)
    ) {
      tabs.tabsData[currentShareId].config.base = mlBase;
      tabs.tabsData[currentShareId].unsaved = true;
      tabs.tabsData[currentShareId].isSaved = false;
    }
  }, [mlBase, currentShareId]);

  return (
    <Provider store={store}>
      <Wrapper>
        <MetricLens {...props} />
      </Wrapper>
    </Provider>
  );
};

export default Dashboard;
